// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"728":"c5a95ab9","787":"84af8404"}[chunkId] + ".chunk.js";
};